import { useEffect, useRef, useState } from 'react';

const reduced = () => typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

/**
 * A whole number that tweens from its previous value (0 on first load) to the new one,
 * strong ease-out, ~800ms. Anything that isn't a plain integer ("£59.0k", "—") renders as-is.
 */
const CountUp = ({ value, duration = 800 }) => {
  const isInt = typeof value === 'number' || /^\d+$/.test(String(value ?? ''));
  const target = isInt ? Number(value) : null;
  const from = useRef(0);
  const [shown, setShown] = useState(isInt && !reduced() ? 0 : target);

  useEffect(() => {
    if (target == null) return undefined;
    if (reduced()) { from.current = target; setShown(target); return undefined; }
    const start = from.current;
    const t0 = performance.now();
    let raf;
    const step = (now) => {
      const t = Math.min(1, (now - t0) / duration);
      const v = Math.round(start + (target - start) * (1 - (1 - t) ** 4));
      setShown(v);
      if (t < 1) raf = requestAnimationFrame(step); else from.current = target;
    };
    raf = requestAnimationFrame(step);
    return () => { cancelAnimationFrame(raf); from.current = target; };
  }, [target, duration]);

  return isInt ? shown : value;
};

export default CountUp;
